import { SVGProps, Ref, forwardRef } from 'react';

export const SpeakerWaveFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M8.81 13.763c-.522.555-1.255.067-2.721-.909L3.98 11.451q-.36-.24-.682-.456-.145.003-.3.002C.375 10.997 0 10.622 0 7.998s.375-3 3-3q.153 0 .299.003.32-.217.682-.456l2.108-1.403c1.466-.976 2.2-1.464 2.72-.91.522.556.522 1.825.522 4.363v2.806c0 2.538 0 3.807-.521 4.362"
                fill="currentColor"
            />
            <path
                d="m13.277 11.957 1.12.84a7.96 7.96 0 0 0 1.599-4.799c0-1.8-.595-3.462-1.6-4.799l-1.12.84a6.57 6.57 0 0 1 1.32 3.959c0 1.485-.491 2.856-1.32 3.959"
                fill="currentColor"
            />
            <path
                d="M13.33 7.998c0 1.2-.397 2.308-1.066 3.2l-1.12-.84a3.9 3.9 0 0 0 .786-2.36c0-.885-.293-1.702-.786-2.36l1.12-.84a5.3 5.3 0 0 1 1.066 3.2"
                fill="currentColor"
            />
        </g>
    </svg>
));
SpeakerWaveFilledSize16Glyph.displayName = 'SpeakerWaveFilledSize16Glyph';
